import { UserAddress } from "@shared/types/UserAccountTypes.interface";
import { apiGet, apiPut } from "./apiHelper";
import { CheckoutAddress } from "./apiOrder";

interface AddressResponse {
    customerNumber: string;
    addresses: UserAddress[];
    statusCode: number;
}

const mapAddresses = (addresses: UserAddress[]) => {
    if (addresses) {
        return addresses.map((address, index) => ({
          ...address, id: index.toString()
        }));
    }
    
    return addresses
}

export const fetchAddresses = async (customerNumber: string): Promise<AddressResponse> => {
    const url = `/api/addressBook/${customerNumber}`;
    const response = await apiGet<AddressResponse>(url);

    if (!response) {
        throw new Error("Failed to fetch adresses");
    }

    if (response.statusCode !== 200) {
        return { customerNumber, addresses: [], statusCode: response.statusCode };
    }
    
    return {
        customerNumber: response.data?.customerNumber ?? customerNumber,
        addresses: mapAddresses(response.data?.addresses) ?? [],
        statusCode: response.statusCode
    }
};

export const updateAddressList = async (customerNumber: string, addresses: UserAddress[]): Promise<AddressResponse> => {
    const url = `/api/addressBook`;
    const body = {
        customerNumber,
        addresses
    }

    const response = await apiPut<UserAddress[]>(url, body);
    
    if (!response) {
        throw new Error("Failed to fetch adresses");
    }
    
    return {
        customerNumber: customerNumber,
        addresses: [],
        statusCode: response.statusCode
    }
};

export const matchAddress = (address: UserAddress, searchQuery: string): boolean => {
    const json = JSON.stringify(address).toLowerCase();
    return json.includes(searchQuery.toLowerCase());
}

export const mapToCheckoutAddress = (address: UserAddress): CheckoutAddress => {
    return {
        name: address?.companyName || "",
        alias: address?.alias || "",
        streetName: address?.streetName || "",
        zipCodeId: address?.postalCode || "",
        stateName: address?.stateName || "",
        cityName: address?.cityName || "",
        countyName: address?.countyName || "",
        countryId: address?.countryId || "",
    }
}